module.exports = __webpack_public_path__ + "media/packs/images/flags/RU-59c05dbb77339f9d4113704baad85930.png";